import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { lottieAnimations, TimedProgressPage } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { RootState } from '@backrs_ui/grow-ui/src/redux/store';
import { selectUserSurveyResults } from '@backrs_ui/grow-ui/src/redux/userResponse/userResponse';
import { useDemoAwareRoute } from '@backrs_ui/grow-ui/src/utils/demoUtils';

import { useAgentContext } from './GeneratingBlueprintPageContainer.agentContext';

const CALIBRATING_DURATION_MS = 5000;

export const GeneratingBlueprintPageContainer = () => {
  const navigate = useNavigate();
  const surveyRoute = useDemoAwareRoute(APP_ROUTE.SURVEY);
  const myBlueprintRoute = useDemoAwareRoute(APP_ROUTE.MY_BLUEPRINT);

  const surveyResults = useSelector((state: RootState) => selectUserSurveyResults(state));

  const countOfTopMiddle = surveyResults?.careerPathSuggestions.filter(
    (suggestion) => suggestion.scoreSection !== 'LOW',
  ).length;

  useAgentContext(surveyResults?.tier, countOfTopMiddle);

  // The blueprint is persisted at survey submission (against the user's session,
  // or the guest session for unauthenticated visitors), so this page only runs the
  // calibrating animation before advancing to the blueprint.
  useEffect(() => {
    if (!surveyResults) {
      navigate(surveyRoute);
    }
  }, [surveyResults, navigate, surveyRoute]);

  if (!surveyResults) {
    // we will redirect with the useEffect above if we don't have survey results, but need this for TypeScript
    return null;
  }

  return (
    <TimedProgressPage
      title={appStrings.modules.survey.calculatingBlueprint}
      animationData={lottieAnimations.paperMap}
      durationMs={CALIBRATING_DURATION_MS}
      onComplete={() => navigate(myBlueprintRoute)}
    />
  );
};
